const getLanguage = () => {
  let language = localStorage.getItem("language")
    ? localStorage.getItem("language")
    : navigator.language;
  if (
    language === "nn" ||
    language === "nb" ||
    language === "no" ||
    language === "nn-NO" ||
    language === "nb-NO" ||
    language === "nb-SJ" ||
    language === "se" ||
    language === "se-NO"
  ) {
    language = "nb";
  } else if (
    language === "en" ||
    language === "en-GB" ||
    language === "en-US" ||
    language === "en-CA"
  ) {
    language = "en";
  } else if (
    language === "de" ||
    language === "de-AT" ||
    language === "de-CH" ||
    language === "de-DE" ||
    language === "de-LI" ||
    language === "de-LU"
  ) {
    language = "de";
  } else if (language === "ro" || language === "ro-RO") {
    language = "ro";
  } else if (
    language === "sv" ||
    language === "sv-FI" ||
    language === "sv-SE"
  ) {
    language = "sv";
  } else if (language === "da") {
    language = "da";
  } else if (
    language === "fr" ||
    language === "fr-BE" ||
    language === "fr-CA" ||
    language === "fr-CH" ||
    language === "fr-FR"
  ) {
    language = "fr";
  } else if (language === "th") {
    language = "th";
  } else {
    language = "en";
  }

  return language;
};

export default getLanguage;
